import { useSelector } from 'react-redux';
import { Alert, AlertTitle } from '@mui/material';
import { useLDFlags } from '../../providers/ld-flags';

export const MedicalDisclaimer = () => {
  const { medicalDisclaimerCopy } = useSelector(useLDFlags);
  // The default copy to use as a backup for the LD flag.
  const defaultDisclaimerCopy = `Your state’s laws prevent your psychiatrist from prescribing some
      medications without an in-person visit, and we only provide virtual care.
      If this affects your treatment, your psychiatrist will talk through your
      options.`;
  const disclaimerCopy: string = medicalDisclaimerCopy || defaultDisclaimerCopy;

  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      <AlertTitle>An important note about medication</AlertTitle>
      {disclaimerCopy}
    </Alert>
  );
};
